// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2UOpd","blueColor":"Button_blueColor__DGK1M","redColor":"Button_redColor__2ye0c"};